import {
  HYDRATE,
  HydrateAction,
} from '@/core/applicationState/store/hydrateAction';
import { SpartacuxProductDiscoveryDomainState } from '@/productDiscovery/productDiscovery.model';
import { sponsoredDataInitialState } from '@/productDiscovery/ProductPage/interfaces/SponsoredDataState.model';
import {
  DISABLE_SPONSORED_PRODUCTS,
  GET_SPONSORED_DATA_HIGHLIGHTED_PRODUCT_SUCCESS,
  GET_SPONSORED_DATA_PLAYLIST_SUCCESS,
  GET_SPONSORED_DATA_TOP_PRODUCT_SUCCESS,
  INIT_SPONSORED_DATA,
  SponsoredDataActions,
} from '@/productDiscovery/ProductPage/modules/SponsoredData/sponsoredData.actions';

const emptyState = {
  data: [],
  fetched: false,
};

export const selectSponsoredData = (
  state: SpartacuxProductDiscoveryDomainState,
) =>
  state.productDiscovery?.productPage?.sponsoredData ||
  sponsoredDataInitialState;

export const selectTopProducts = (
  state: SpartacuxProductDiscoveryDomainState,
) => state.productDiscovery?.productPage?.sponsoredData?.topProducts || [];

export const selectHighlightedProducts = (
  state: SpartacuxProductDiscoveryDomainState,
) =>
  state.productDiscovery?.productPage?.sponsoredData?.highlightedProducts ||
  emptyState;

export const selectSponsoredPlaylistProducts = (
  state: SpartacuxProductDiscoveryDomainState,
) =>
  state.productDiscovery?.productPage?.sponsoredData?.sponsoredPlaylist ||
  emptyState;
export const selectSponsoredProductsDisabled = (
  state: SpartacuxProductDiscoveryDomainState,
) =>
  state.productDiscovery?.productPage?.sponsoredData
    ?.sponsoredProductsDisabled ?? false;

export default (
  state = sponsoredDataInitialState,
  action:
    | HydrateAction<SpartacuxProductDiscoveryDomainState>
    | SponsoredDataActions,
) => {
  switch (action.type) {
    case HYDRATE:
      return selectSponsoredData(action.state);

    case INIT_SPONSORED_DATA:
      return sponsoredDataInitialState;

    case GET_SPONSORED_DATA_TOP_PRODUCT_SUCCESS:
      return {
        ...state,
        topProducts: action.topProducts,
      };

    case GET_SPONSORED_DATA_HIGHLIGHTED_PRODUCT_SUCCESS:
      return {
        ...state,
        highlightedProducts: {
          data: action.highlightedProducts,
          fetched: true,
        },
      };

    case GET_SPONSORED_DATA_PLAYLIST_SUCCESS:
      return {
        ...state,
        sponsoredPlaylist: {
          data: action.sponsoredPlaylist,
          fetched: true,
        },
      };

    case DISABLE_SPONSORED_PRODUCTS:
      return {
        ...state,
        sponsoredProductsDisabled: true,
      };

    default:
      return state;
  }
};
